import type { LogsEvent } from '@datadog/browser-logs'

const isNonHttpUrl = (url: string) => !url.startsWith('/') && !/^https?:\/\//i.test(url)

export const isIgnorableLogsEvent = ({ http, origin }: LogsEvent) =>
  origin === 'network' && !!http?.url && isNonHttpUrl(http.url)
